<div class="icons-wrapper">
  <!-- Main Menu Icons -->
  <div class="icons-wrapper__container" *ngIf="isShowAllIcons">
    <div class="row mr-0 ml-0 mb-2 justify-content-center">
      <!-- icon TEXT -->
      <div class="col-4 pl-0 pr-0">
        <span (click)="iconAction('text')" class="icons-wrapper__container-clickable">
          <img [src]="weblinkIcons.text" alt="text" class="icons-wrapper__container-img-text">
          <div class="icons-wrapper__container-text">Text</div>
        </span>
      </div>
      <!-- icon CALL -->
      <div class="col-4 pl-0 pr-0">
        <a *ngIf="mediaData?.is_public"> <!--href="tel:{{user_mobile}}"  -->
          <img [src]="weblinkIcons.call" alt="call" class="icons-wrapper__container-img">
          <div class="icons-wrapper__container-text">Call</div>
        </a>
        <span *ngIf="!mediaData?.is_public" class="icons-wrapper__container-clickable"> <!-- (click)="iconAction('call')" -->
          <img [src]="weblinkIcons.call" alt="mute" class="icons-wrapper__container-img">
          <div class="icons-wrapper__container-text">Call</div>
        </span>
      </div>
      <!-- icon EMAIL -->
      <div class="col-4 pl-0 pr-0">
        <a *ngIf="mediaData?.is_public" class="icons-wrapper__container-clickable"> <!-- href="mailto:{{user_email}}" -->
          <img [src]="weblinkIcons.email" alt="email" class="icons-wrapper__container-img">
          <div class="icons-wrapper__container-text">E-Mail</div>
        </a>
        <span *ngIf="!mediaData?.is_public" class="icons-wrapper__container-clickable"> <!-- (click)="iconAction('email')" -->
          <img [src]="weblinkIcons.email" alt="mute" class="icons-wrapper__container-img">
          <div class="icons-wrapper__container-text">E-Mail</div>
        </span>
      </div>
    </div>
    <div class="row mr-0 ml-0 mb-2 justify-content-center">
      <!-- icon LOCATION -->
      <div class="col-4 pl-0 pr-0">
        <span (click)="openMedia(mediaData?.info_links.googlemap, 'Location')" class="icons-wrapper__container-clickable">
          <img [src]="weblinkIcons.location" alt="location" class="icons-wrapper__container-img">
          <div class="icons-wrapper__container-text">Location</div>
        </span>
      </div>
      <!-- icon POSTCARD -->
      <div class="col-4 pl-0 pr-0">
        <span (click)="openMedia('postcard')" class="icons-wrapper__container-clickable">
          <img [src]="weblinkIcons.postcard" alt="postcard" class="icons-wrapper__container-img">
          <div class="icons-wrapper__container-text">Post<span style="font-weight: bold;">Cards</span></div>
        </span>
      </div>
      <!-- icon PROFILE -->
      <div class="col-4 pl-0 pr-0">
        <span (click)="iconAction('profile')" class="icons-wrapper__container-clickable">
          <img [src]="weblinkIcons.profile" alt="profile" class="icons-wrapper__container-img">
          <div class="icons-wrapper__container-text">Profile</div>
        </span>
      </div>
    </div>
    <div class="row mr-0 ml-0 mb-3 justify-content-center">
      <!-- icon WEBSITE -->
      <div class="col-4 pl-0 pr-0">
        <span (click)="openMedia(mediaData?.info_links.www, 'Website')" class="icons-wrapper__container-clickable">
          <img [src]="weblinkIcons.website" alt="website" class=" icons-wrapper__container-img">
          <div class="icons-wrapper__container-text">Website</div>
        </span>
      </div>
      <!-- icon FEATURE CONTENT -->
      <div class="col-4 pl-0 pr-0">
        <span (click)="iconAction('featured_content')" class="icons-wrapper__container-clickable">
          <img [src]="weblinkIcons.feature_content" alt="feature_content" class="icons-wrapper__container-img">
          <div class="icons-wrapper__container-text">Featured Content</div>
        </span>
      </div>
      <!-- icon SOCIAL LINK -->
      <div class="col-4 pl-0 pr-0">
        <span (click)="iconAction('social_link')" class="icons-wrapper__container-clickable">
          <img [src]="weblinkIcons.social_link" alt="social_link" class="icons-wrapper__container-img" [ngClass]="{'icons-wrapper__container-clickable': mediaData?.socials?.length}">
          <div class="icons-wrapper__container-text">Social Links</div>
        </span>
      </div>
    </div>
    <!-- icon DOWNLOAD NOW -->
    <div class="icons-wrapper__container-download">
      <a (click)="openMedia('download')">
        <img [src]="weblinkIcons.download_now" alt="download">
      </a>
    </div>

    <div *ngIf="isShowToast" class="icons-wrapper__container-toast" [ngClass]="isShowToast ? 'icons-wrapper__container-toast-show' : 'icons-wrapper__container-toast-hide'">{{toastMessage}}</div>
  </div>
  <!-- show all text icons -->
  <div class="icons-wrapper__container" *ngIf="isShowActionTextIcons && !isShowAllIcons" [ngClass]="{'icons-wrapper__container-mt4': isShowActionTextIcons && !isShowAllIcons}">
    <div class="row justify-content-center">
      <!-- icon SMS -->
      <div class="col-4 pl-0 pr-0">
        <a href="sms:{{user_mobile}}">
          <img [src]="weblinkIcons.sms_white" alt="sms_white" class="icons-wrapper__container-img">
          <div class="icons-wrapper__container-text">SMS</div>
        </a>
      </div>
      <!-- icon WHATSAPP -->
      <div class="col-4 pl-0 pr-0">
        <span (click)="openMedia('whatsapp')" class="icons-wrapper__container-clickable">
          <img [src]="weblinkIcons.whatsapp_white" alt="whatsapp_white" class="icons-wrapper__container-img">
          <div class="icons-wrapper__container-text">WhatsApp</div>
        </span>
      </div>
      <!-- icon Z-BUZZ -->
      <div class="col-4 pl-0 pr-0">
        <span (click)="openMedia('zbuzz')" class="icons-wrapper__container-clickable">
          <img [src]="weblinkIcons.z_buzz" alt="z_buzz" class="icons-wrapper__container-img icons-wrapper__container-img-text">
          <div class="icons-wrapper__container-text">Z-Buzz</div>
        </span>
      </div>
    </div>
  </div>
  <!-- show all social icons -->
  <div class="icons-wrapper__container" *ngIf="isShowActionSocialLinkIcons && !isShowAllIcons" [ngClass]="{'icons-wrapper__container-mt4': isShowActionSocialLinkIcons && !isShowAllIcons}">
    <!-- icon SOCIALS -->
    <div class="row mr-0 ml-0">
      <div *ngFor="let social of mediaData?.socials; let i = index" class="pl-0 pr-0"
          [ngClass]="isSocialIconNot5or7Above ? socialIconColumn : 'icons-wrapper__container-social-dynamic'">
          <span (click)="openMedia(social.link)" class="icons-wrapper__container-clickable">
            <img [src]="social.icon" [alt]="social.icon" class="icons-wrapper__container-img">
            <div class="icons-wrapper__container-text">{{social?.label}}</div>
          </span>
      </div>
    </div>
  </div>
  <!-- footer -->
  <div class="icons-wrapper__footer" *ngIf="isShowAllIcons" [ngStyle]="{'background-color': barColor}">
    <div *ngIf="mediaData?.custom_links?.length > 0" class="row justify-content-center">
      <div *ngFor="let custom of mediaData?.custom_links" class="col-{{footerIconColumn}} pl-2 pr-2 icons-wrapper__footer-col">
        <span (click)="footerActionOpen(custom.link)" class="icons-wrapper__footer-text"
          [ngClass]="(defineBgColorBarBottom === 'dark') ? 'icons-wrapper__text-white' : 'icons-wrapper__text-black'">
          {{custom.label}}
        </span>
        <div class="icons-wrapper__footer-text-divider" [style.background]="(defineBgColorBarBottom === 'dark') ? '#fff' : 'rgb(1,21,1)'"></div>
      </div>
    </div>
  </div>
</div>
